
import { useEffect, useState, } from 'react';

import Box from '@mui/material/Box';

import { styled } from '@mui/material/styles';


import TextField from '@mui/material/TextField';

import Stack from '@mui/material/Stack';

import Alert from '@mui/material/Alert';

import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import CloseIcon from '@mui/icons-material/Close';


import { encodeTag, decodeTag } from '../helpers/assets';

import { getSessionIdToken } from '../auth/apiAuth'

import axios from 'axios';

const {
    REACT_APP_USER_ID,
} = process.env;


const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};




export default function AssetEditTags({ document, uploadOpen,
    tagsKeys, auth, folderDocuments,
    handleUploadDialogClose, handleRefreshTable }) {

    const [uploadInddTag, setUploadInddTag] = useState(tagsKeys.map(t => { return { Key: t, Value: document.tags[t] } }))
    const [isUpdatingDoc, setIsUpdatingDoc] = useState(false);

    const handleChangeInddTag = (tag, value, document) => {
        const tagList = uploadInddTag.map(t => {
            if (t.Key === tag) {
                t.Value = value
            }
            return t
        });

        setUploadInddTag(tagList)
    }

    const normalizeTagValue = (v) => (v == null ? '' : String(v).trim());

    const isDuplicateCombination = Array.isArray(folderDocuments) && folderDocuments.some(sibling => {
        if (!sibling || !sibling.tags) return false;
        if (sibling.reqid === document.reqid) return false;
        return uploadInddTag.every(t => normalizeTagValue(sibling.tags[t.Key]) === normalizeTagValue(t.Value));
    });

    const handleUpdateDocument = async () => {
      //  console.log('update doc', uploadInddTag, document.indd.fullPath)
      setIsUpdatingDoc(true)
        const uriEncodedTags = uploadInddTag.map(tagObj => { return { Key: encodeURIComponent(encodeTag(tagObj.Key)), Value: encodeURIComponent(encodeTag(tagObj.Value))}})
        //console.log('update tags', uriEncodedTags)
        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_BASE_URL}/assets`,
            headers: {
                'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                "content-type": "application/json",
                "Authorization": await getSessionIdToken(),
                "action": 'dynamo-update-tags',
                "docfullpath": encodeURIComponent(document.indd.fullPath),
                "project_id": document.indd.project_id,
                "key": document.indd.key,
                "tags": JSON.stringify(uriEncodedTags)
            },
        })

        .then((resp)=>{
            handleRefreshTable();
        })
            .catch(err => {
                console.error('Tags error');
            })
            .finally(()=>{
                setIsUpdatingDoc(false);
                handleUploadDialogClose();
            });
    }

    //console.log('edit panel', docPath, tagsKeys)

    return <Dialog
        disableEscapeKeyDown={true}
        fullWidth
        maxWidth='md'
        onClose={handleUploadDialogClose}
        aria-labelledby="customized-dialog-title"
        open={uploadOpen}
    >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleUploadDialogClose}>
            <b>{document.filename}</b>
        </BootstrapDialogTitle>
        <DialogContent dividers>
            <Stack spacing={2}>
                <Box>
                    {tagsKeys.map(tag => {
                        const tagValue = uploadInddTag.filter(t => t.Key === tag).shift().Value;
                        const isEmpty = !tagValue || tagValue.trim() === '';
                        return (
                            <TextField
                                key={tag}
                                label={tag}
                                value={tagValue}
                                size='small'
                                error={isEmpty}
                                helperText={isEmpty ? 'Tag cannot be empty' : ''}
                                onChange={(event) => handleChangeInddTag(tag, event.target.value)}
                                sx={{ mr: '1em', mt: '1em' }}
                            />
                        );
                    })}

                </Box>
                {isDuplicateCombination && (
                    <Alert severity="error">
                        This combination of tags is already used by another document in this folder.
                    </Alert>
                )}
                <Box>

                    <Button
                        variant="contained"
                        component="label"
                        color='secondary'
                        loading={isUpdatingDoc}
                        loadingIndicator={<CircularProgress color="inherit" size={16} variant='indeterminate' />}
                        disabled={uploadInddTag.some(t => !t.Value || t.Value.trim() === '') || isDuplicateCombination}
                        onClick={handleUpdateDocument}>

                        Update tags
                    </Button>
                </Box>
            </Stack>
        </DialogContent>

    </Dialog>
}